import React, { useEffect, useState } from "react";
import { postData, putData } from '../../../../services/library';
import { Typography, Grid, Box, Card, TextField, InputAdornment, CardContent, Dialog, Button } from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";
import moment from "moment";
import { logEventos } from "../../../../services/services";
import Notify from "../../../Notify";

function Actualizar_precio_especial(props) {
  const { datosExisten, open } = props;

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const [datoslista, setDatoslista] = useState({
    id_cliente: datosExisten.id_cliente,
    lt_con_iva: "",
    lt_sin_iva: "",
    kg_con_iva: "",
    kg_sin_iva: "",
    vigencia: "",
    fin_vigencia: null
  });

  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  const [disabledGuardar, setDisabledGuardar] = useState(false);
  const fechaVigencia = moment(datoslista.vigencia);//Fecha fin vigencia
  const fechaFinVigencia = fechaVigencia.subtract(1, "day");
  const fechaFinVigenciaPut = fechaFinVigencia.format("YYYY-MM-DD");

  const almacenar = (e) => {
    setDatoslista({
      ...datoslista,
      [e.target.name]: e.target.value,
    });
  };

  //*********************************** OBTENER **************************************************************************************************/
  const [aumento, setAumento] = useState(null);
  const [desactivarPorcentaje, setDesactivarPorcentaje] = useState(false);
  const [desactivarPesos, setDesactivarPesos] = useState(false);
  const [porcentaje, setPorcentaje] = useState(null);

  const restaurarPrecios = () => {
    setDatoslista((prev) => ({
      ...prev,
      kg_sin_iva: parseFloat(datosExisten.kg_sin_iva).toFixed(2),
      lt_sin_iva: parseFloat(datosExisten.lt_sin_iva).toFixed(2),
      kg_con_iva: parseFloat(datosExisten.kg_con_iva).toFixed(2),
      lt_con_iva: parseFloat(datosExisten.lt_con_iva).toFixed(2),
    }));
  };

  const formatearDecimal = (num) => Number(num).toFixed(2).replace('.', ',');

  const handleAumentoChange = (e) => {
    const nuevoAumento = e.target.value;
    setAumento(nuevoAumento);
    setPorcentaje(null)
    setDesactivarPorcentaje(nuevoAumento !== "");

    if (nuevoAumento === "") {
      setDatoslista({
        ...datoslista,
        kg_sin_iva: "",
        lt_sin_iva: "",
        kg_con_iva: "",
        lt_con_iva: "",
      });
      return;
    }

    if (!isNaN(nuevoAumento)) {
      const aumentoNumerico = parseFloat(nuevoAumento);
      const nuevoPrecioKiloSinIva = datosExisten.kg_sin_iva + aumentoNumerico;

      const densidad = datosExisten.id_empresa === 1
        ? datosExisten.densidad_hipergas
        : datosExisten.densidad_autogas;

      const nuevoPrecioLitroSinIva = nuevoPrecioKiloSinIva * densidad;
      const nuevoPrecioKiloConIva = nuevoPrecioKiloSinIva * datosExisten.valor;
      const nuevoPrecioLitroConIva = nuevoPrecioLitroSinIva * datosExisten.valor;

      setDatoslista((prev) => ({
        ...prev,
        kg_sin_iva: formatearDecimal(nuevoPrecioKiloSinIva),
        lt_sin_iva: formatearDecimal(nuevoPrecioLitroSinIva),
        kg_con_iva: formatearDecimal(nuevoPrecioKiloConIva),
        lt_con_iva: formatearDecimal(nuevoPrecioLitroConIva),
      }));
    } else {
      restaurarPrecios();
    }
  };

  const handlePorcentajeChange = (e) => {
    const nuevoPorcentaje = e.target.value;
    setPorcentaje(nuevoPorcentaje);
    setDesactivarPesos(nuevoPorcentaje !== "");
    setAumento(null);

    if (nuevoPorcentaje === "") {
      setDatoslista({
        ...datoslista,
        kg_sin_iva: "",
        lt_sin_iva: "",
        kg_con_iva: "",
        lt_con_iva: "",
      });
      return;
    };

    if (!isNaN(nuevoPorcentaje)) {
      const porcentajeNumerico = parseFloat(nuevoPorcentaje) / 100;
      const nuevoPrecioKiloSinIva = datosExisten.kg_sin_iva * (1 + porcentajeNumerico);

      const densidad = datosExisten.id_empresa === 1
        ? datosExisten.densidad_hipergas
        : datosExisten.densidad_autogas;

      const nuevoPrecioLitroSinIva = nuevoPrecioKiloSinIva * densidad;
       const nuevoPrecioLitroConIva = nuevoPrecioLitroSinIva * datosExisten.valor;
      const nuevoPrecioKiloConIva = nuevoPrecioKiloSinIva * datosExisten.valor;

      setDatoslista((prev) => ({
        ...prev,
        kg_sin_iva: formatearDecimal(nuevoPrecioKiloSinIva),
        lt_sin_iva: formatearDecimal(nuevoPrecioLitroSinIva),
        kg_con_iva: formatearDecimal(nuevoPrecioKiloConIva),
        lt_con_iva: formatearDecimal(nuevoPrecioLitroConIva),
      }));
    } else {
      restaurarPrecios();
    }
  };

  const handleClose = () => {
    open(false);
    props.tabla(true);
    props.actualizar()
  };

  //*************************** GUARDAR *******************************************************************************************************//
  const guardarPrecio = async (e) => {
    const parseDecimal = (str) => {
            if (typeof str === 'string') {
                return parseFloat(str.replace(',', '.'));
            }
            return str;
        };
    //cargo el nuevo precio
    postData(e,
      '/precios_especiales',
      {
        id_cliente: datosExisten.id_cliente,
        lt_con_iva: parseDecimal(datoslista.lt_con_iva),
        lt_sin_iva: parseDecimal(datoslista.lt_sin_iva),
        kg_con_iva: parseDecimal(datoslista.kg_con_iva),
        kg_sin_iva: parseDecimal(datoslista.kg_sin_iva),
        vigencia: datoslista.vigencia,
        usuario: localStorage.getItem("user"),
        aumento_en_pesos: aumento,
        aumento_en_porcentaje: porcentaje
      },
      setNotificacion
    )

    //luego le pongo fecha de fin de vigencia a la lista
    putData(e,
      `/precios_especiales/${datosExisten.id_precioespecial}`,
      {
        fin_vigencia: fechaFinVigenciaPut,
        usuario: localStorage.getItem('user')
      },
      setNotificacion,

    )
    logEventos(
      "Guardar actualización del precio",
      "LISTA DE PRECIOS GRANEL",
      "Actualiza cierre de vigencia en pedido seleccionado y crea otro ",
      localStorage.getItem("user")
    );

  };

  useEffect(() => {
    if ((!aumento && !porcentaje) || !datoslista.vigencia) {
      setDisabledGuardar(true);
    } else {
      setDisabledGuardar(false);
    }
  }, [aumento, porcentaje, datoslista.vigencia]);

  const formatoParaMostrar = (valor) => {
    if (valor === null || valor === undefined) return '';
    // Si es número, lo paso a string con coma
    if (typeof valor === 'number') {
      return valor.toFixed(2).replace('.', ',');
    }
    // Si es string, reemplazo punto por coma
    return valor.replace('.', ',');
  };

  return (
    <div>

      <Dialog open={open} fullWidth maxWidth="xl" onClose={handleClose}>
        {datosExisten && (
          <Box sx={{ padding: 2 }}>
            <Card variant="outlined" sx={{ mb: 1, backgroundColor: "#F4F6F6" }}>
              <CardContent>
                <Typography sx={{ fontSize: 19, mb: 2, textDecoration: "underline", textAlign: "center" }}>
                  Precio Vigente
                </Typography>
                {/* Precios en un solo renglón */}
                <Grid container spacing={1} alignItems="center" justifyContent="center">
                  {[
                    { label: "Precio litro sin IVA", value: datosExisten.lt_sin_iva || 0 },
                    { label: "Precio litro con IVA", value: datosExisten.lt_con_iva || 0 },
                    { label: "Precio kilo sin IVA", value: datosExisten.kg_sin_iva || 0 },
                    { label: "Precio kilo con IVA", value: datosExisten.kg_con_iva || 0 },
                  ].map((item, index) => (
                    <Grid item xs={12} sm={6} md={2} key={index}>
                      <TextField
                        fullWidth
                        style={style}
                        focused
                        size="small"
                        variant="outlined"
                        label={item.label}
                        value={formatoParaMostrar(item.value)}
                        InputProps={{ readOnly: true }}
                      />
                    </Grid>
                  ))}
                  {/* Fechas de Vigencia */}
                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      fullWidth
                      style={style}
                      focused
                      size="small"
                      variant="outlined"
                      label="Entrada en Vigencia"
                      value={moment(datosExisten.vigencia).format("DD-MM-YYYY") || ""}
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                </Grid>
              </CardContent>

              <CardContent>
                <Typography sx={{ fontSize: 19, mb: 2, textDecoration: "underline", textAlign: "center" }}>
                  Actualizacion
                </Typography>
                <Grid container spacing={1} alignItems="center" justifyContent="center">
                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      fullWidth
                      style={style}
                      focused
                      size="small"
                      color="secondary"
                      label="Actualización en pesos"
                      variant="outlined"
                      type="number"
                      value={aumento}
                      onChange={handleAumentoChange}
                      disabled={desactivarPesos}
                      InputProps={{
                        startAdornment: <InputAdornment position="start"><AttachMoneyIcon /></InputAdornment>,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={2}>


                    <TextField
                      fullWidth
                      size="small"
                      style={style}
                      focused
                      type="number"
                      color="secondary"
                      label="Actualización en porcentaje"
                      variant="outlined"
                      value={porcentaje}
                      onChange={handlePorcentajeChange}
                      disabled={desactivarPorcentaje}
                      InputProps={{
                        startAdornment: <InputAdornment position="start"><PercentIcon /></InputAdornment>,
                      }}
                    />
                  </Grid>
                </Grid>
              </CardContent>

              <CardContent>
                <Typography sx={{ fontSize: 19, mb: 2, textDecoration: "underline", textAlign: "center" }}>
                  Precio actualizado
                </Typography>
                {/* Precios con aumento en un solo renglón */}
                <Grid container spacing={1} alignItems="center" justifyContent="center">
                  {[
                    { label: "Precio litro sin IVA", name: "lt_sin_iva", value: datoslista.lt_sin_iva || 0 },
                    { label: "Precio litro con IVA", name: "lt_con_iva", value: datoslista.lt_con_iva || 0 },
                    { label: "Precio kilo sin IVA", name: "kg_sin_iva", value: datoslista.kg_sin_iva || 0 },
                    { label: "Precio kilo con IVA", name: "kg_con_iva", value: datoslista.kg_con_iva || 0 },
                  ].map((item, index) => (
                    <Grid item xs={12} sm={6} md={2} key={index}>
                      <TextField
                        fullWidth
                        style={style}
                        focused
                        size="small"
                        variant="outlined"
                        label={item.label}
                        name={item.name}
                        value={formatoParaMostrar(item.value)}
                        onChange={almacenar}
                        InputProps={{
                          readOnly: true,
                          startAdornment:
                            <InputAdornment position="start">
                              <AttachMoneyIcon /></InputAdornment>
                        }}
                      />
                    </Grid>
                  ))}
                  {/* Fecha Minima */}
                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      fullWidth
                      style={style}
                      focused
                      size="small"
                      variant="outlined"
                      label="Fecha de entrada en vigencia"
                      type="date"
                      inputProps={{ min: moment(datosExisten.vigencia).format("YYYY-MM-DD") }}
                      name="vigencia"
                      value={datoslista.vigencia || ""}
                      onChange={almacenar}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="flex-end"
                  mt={2}
                >
                  <Button variant="contained"
                    onClick={() => open(false)}
                    color="error">
                    Volver
                  </Button>

                  <Button
                    variant="contained"
                    type="submit"
                    color={"success"}
                    onClick={guardarPrecio}
                    disabled={disabledGuardar}
                  >
                    Actualizar
                  </Button>
                </Grid>
              </CardContent>
            </Card>
          </Box>
        )}
        {notificacion && notificacion.open ? (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={handleClose}
            severity={notificacion.severity}
          />
        ) : null}
      </Dialog>

    </div>
  );
}

export default Actualizar_precio_especial;

//----- Component --------------------------------------------------------/
// Developer :  Daiana Curcio / Nicolas pascucci
// Creation Date :19/06/2024
// Version : 1
// Description : Actualizar precio
//------Changes ----------------------------------------------------------//
// Change Date : 15/8
// Change by : Candela Grosso
// Change description: OBVUAMENTE LO PUSE EN UN DIALOG PORQUE QUEDABA MEJOR J3J3J3J3J 
// Change Date :3/7/2025
// Change by : Candela Grosso
// Change description: Los precios se separan los decimales con coma y y decimales
//========================================================================/
